import { dataService } from '../services/dataService.js';
import { createMovieCard } from '../components/MovieCard.js';
import { seoService } from '../services/seoService.js';

export async function renderWatchlistView() {
  seoService.update({
    title: 'My Saved Watchlist',
    description: 'Your saved Sri Lankan movies and favorites on CinemaHala.'
  });

  const container = document.createElement('div');
  container.className = 'main-content';

  let savedIds = [];
  try {
    savedIds = JSON.parse(localStorage.getItem('cmdb_watchlist') || '[]');
  } catch (e) {
    savedIds = [];
  }

  container.innerHTML = `
    <div class="section-header">
      <h1 class="section-title">My Saved Watchlist</h1>
    </div>
  `;

  if (savedIds.length === 0) {
    const emptyState = document.createElement('div');
    emptyState.style.textAlign = 'center';
    emptyState.style.padding = 'var(--space-2xl) var(--space-md)';
    emptyState.innerHTML = `
      <div style="font-size: 3rem; margin-bottom: var(--space-md);">🎬</div>
      <h3 style="font-size: 1.2rem; font-weight: 700; margin-bottom: 6px;">Your Watchlist is empty</h3>
      <p style="color: var(--text-secondary); font-size: 0.9rem; margin-bottom: var(--space-lg);">
        Bookmark movies you want to watch or revisit later!
      </p>
      <a href="#/" class="btn-primary clickable-item">Discover Movies</a>
    `;
    container.appendChild(emptyState);
    return container;
  }

  const grid = document.createElement('div');
  grid.style.display = 'grid';
  grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(160px, 1fr))';
  grid.style.gap = 'var(--space-md)';
  grid.style.marginTop = 'var(--space-md)';

  for (const id of savedIds) {
    const movie = await dataService.getMovie(id);
    if (movie) {
      grid.appendChild(createMovieCard(movie));
    }
  }

  container.appendChild(grid);
  return container;
}
